var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect, useState } from "react";
import { Client } from "./client";
import { useAsync } from "./use-async";
import { GlobalUi } from './global-ui';
import { ConfigContext, useClient } from "./config";
import { ProvideContent } from "./content";
import { noop } from "./util";
import { ResourceCacheProvider } from "./resource";
export const CmsAdminApp = ({ authProvider, endpoint, children }) => {
    const [authState, setAuthState] = useState();
    useEffect(() => {
        const checkLogin = () => __awaiter(this, void 0, void 0, function* () {
            const token = yield authProvider.init();
            setAuthState({ token });
        });
        checkLogin();
    }, [authProvider]);
    if (!authState) {
        return null;
    }
    if (!authState.token) {
        return React.createElement(authProvider.loginUi, { onLogin: setAuthState });
    }
    return (React.createElement(ConfigContext.Provider, { value: { editable: true, client: new Client(endpoint, authState.token) } }, children));
};
export const CmsPage = ({ children, rootResourceUrl, data = {}, resourceData = {} }) => (React.createElement(ResourceCacheProvider, { rootResourceUrl: rootResourceUrl, initialData: resourceData },
    React.createElement(ProvideContent, { value: data, editable: false, onChange: noop }, children)));
export const CmsAdminPage = ({ children, rootResourceUrl, pageId, resourceData }) => {
    const client = useClient();
    const revision = useAsync(() => __awaiter(this, void 0, void 0, function* () {
        const revision = yield client.getPageRevision(pageId);
        return revision || client.createPageRevision(pageId, { content: {} });
    }), [client]);
    const [editValue, setEditValue] = useState();
    if (!revision) {
        return null;
    }
    const save = () => __awaiter(this, void 0, void 0, function* () {
        if (revision.value) {
            const revisionId = revision.value.id;
            revision.value = yield client.putPageRevision(pageId, revisionId, { content: editValue });
        }
        else {
            revision.value = yield client.createPageRevision(pageId, { content: editValue });
        }
        setEditValue(undefined);
    });
    return (React.createElement(ResourceCacheProvider, { rootResourceUrl: rootResourceUrl, initialData: resourceData },
        React.createElement(ProvideContent, { editable: true, value: editValue || revision.value.content, onChange: setEditValue },
            React.createElement(GlobalUi, { revision: revision.value, onPublish: () => __awaiter(this, void 0, void 0, function* () {
                    yield save();
                    yield client.publish(pageId, revision.value.id);
                    revision.value = yield client.createPageRevision(pageId, { content: revision.value.content });
                }), onSave: save }),
            children)));
};
//# sourceMappingURL=provider.js.map